import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";

export interface CanvasToolsBlockActionsProps
  extends ComponentPropsWithoutRef<"div"> {}

export const CanvasToolsBlockActions = ({
  children,
}: CanvasToolsBlockActionsProps) => {
  const selectedBlockPath =
    useBuilderStore(state => state.selectedBlockPath) ?? "";
  const isFirstBlockSelected =
    selectedBlockPath === "blocks.props.children.value.0";

  const stylesMap = {
    firstBlock: {
      position: "-top-1",
      borderRadius: "rounded-b-[0.3125rem]",
    },
    default: {
      position: "-top-8",
      borderRadius: "rounded-t-[0.3125rem]",
    },
  };
  const styles = isFirstBlockSelected
    ? stylesMap["firstBlock"]
    : stylesMap["default"];

  return (
    <div
      className={classNames(
        "bg-circle pointer-events-auto absolute -right-1 -top-8 flex items-center gap-0.5 p-1",
        styles.position,
        styles.borderRadius,
      )}
    >
      {children}
    </div>
  );
};
